import { render, staticRenderFns } from "./TerminalAnswerScreen.vue?vue&type=template&id=07355c52&scoped=true&"
import script from "./TerminalAnswerScreen.vue?vue&type=script&lang=js&"
export * from "./TerminalAnswerScreen.vue?vue&type=script&lang=js&"
import style0 from "./TerminalAnswerScreen.vue?vue&type=style&index=0&id=07355c52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07355c52",
  null
  
)

export default component.exports